import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  colorComponente: {
    width: "100%",
    backgroundColor: 'white',
  },
  gridContainer: {
    margin: '5px',
    border: '1px solid black',
    borderRadius: '10px',
  },
  gridItemFirst: {
    backgroundColor: 'black',
    color: 'white',
    padding: '11px',
    textAlign: 'center',
    borderRadius: '0px 0px 0px 9px',
  },
  gridItemSecond: {
    backgroundColor: 'white',
    color: "black",
    textAlign: 'center',
  },
  header: {
    height: "10px",
    background: `linear-gradient(90deg, rgba(0,0,0,1) 10%, rgba(62,62,62,1) 51%, rgba(124,124,124,1) 100%)`,
    border: "white",
    borderRadius: '10px 10px 0px 0px',
  },
}));
